module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [(_vm.location) ? _c('div', {
    staticClass: "info__data"
  }, [_vm._v("Адрес проведения: "), _c('span', [_vm._v(_vm._s(_vm.location))])]) : _vm._e(), (_vm.members) ? _c('div', {
    staticClass: "info__data"
  }, [_vm._v("Участники: "), _c('span', [_vm._v(_vm._s(_vm.members))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28bff374","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/OrderInfo.vue
// module id = 959bca3e92ab85aa41f6
// module chunks = 0